"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _reactRouter = require("react-router");

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _ContentStore = _interopRequireDefault(require("../KESI2/Stores/ContentStore"));

var _AppUtils = require("../utils/AppUtils");

var _TimeoutHelper = require("../helpers/TimeoutHelper");

var _Constants = require("./constants/Constants");

var _KesiConstants = require("../KESI2/KesiConstants");

var _BuildConstants = require("../utils/BuildConstants");

// eslint-disable-next-line import/no-extraneous-dependencies, import/extensions, import/no-unresolved
// const defaultTypeRouteMap = {
//   about: 'about',
//   default: 'kesi_home',
//   // external_website: 'external_website',
//   // equeo_external_website: 'equeo_external_website',
//   settings: 'settings'
// }
var _instance = null;
/**
 * This module handles dispatching location changes to the right routes.
 * E.g. it decides whether to open a normal content page or a quiz page.
 */

var NavigationManagerCordova = /*#__PURE__*/function () {
  function NavigationManagerCordova() {
    (0, _classCallCheck2["default"])(this, NavigationManagerCordova);
    this.currentPath = []; // TODO read hash location and init current path

    this.previousPath = null;
    this.onPathChangeListeners = [];
    this.scrollTop = 0;
    this.globalBackFunc = null;
    this.navbarBackgroundColor = null;
    this.isChangingUrl = false;
    this.jumpPath = null;
    this.jumpNavBarColor = null; // this.typeRouteMapping = this.initTypeRouteMapping();
    // this.lastCourseId = null;
  }

  (0, _createClass2["default"])(NavigationManagerCordova, [{
    key: "jumpBack",
    value: function jumpBack() {
      if (this.jumpPath) {
        this.navbarBackgroundColor = this.jumpNavBarColor;
        this.goTo(this.jumpPath);
        this.jumpPath = null;
      } else {
        this.goHome();
      }
    }
  }, {
    key: "goBack",
    value: function goBack() {
      console.log('go back via Navigation Manager');

      if (this.globalBackFunc) {
        this.globalBackFunc();
      } else {
        this.goTo(_config["default"].cordovaStartUrl());
      }
    }
  }, {
    key: "getCurrentId",
    value: function getCurrentId() {
      if (this.currentPath && this.currentPath.length > 0) {
        var idString = this.currentPath[this.currentPath.length - 1];
        var ids = idString.split(_KesiConstants.KESI_PATH_DELIMITER);
        return ids[ids.length - 1];
      }

      return _config["default"].rootId;
    }
  }, {
    key: "getUsedJump",
    value: function getUsedJump() {
      return this.jumpPath !== null;
    }
  }, {
    key: "getCurrentPath",
    value: function getCurrentPath() {
      if (this.currentPath && this.currentPath.length > 0) {
        var path = this.currentPath[this.currentPath.length - 1];
        var pathParts = path.split('/');
        return pathParts.length > 1 ? pathParts[1] : pathParts[0];
      }

      return _config["default"].cordovaStartUrl();
    }
  }, {
    key: "goTo",
    value: function () {
      var _goTo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
        var pushToHistory,
            dontSetIsChanging,
            prevUrl,
            path,
            lastId,
            pathSpocRootId,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pushToHistory = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
                dontSetIsChanging = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                prevUrl = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;

                if (prevUrl) {
                  //that means we are jumping into a tile or lecture, no course
                  this.jumpNavBarColor = this.navbarBackgroundColor;
                  this.jumpPath = prevUrl;
                } else {
                  this.jumpPath = null;
                }

                if (!this.isChangingUrl) {
                  _context.next = 7;
                  break;
                }

                console.log('NavigationManagerCordova goTo not changing url to ' + url + ' because change is progress');
                return _context.abrupt("return");

              case 7:
                if (!dontSetIsChanging) {
                  this.isChangingUrl = true;
                }

                _context.next = 10;
                return (0, _TimeoutHelper.timeout)();

              case 10:
                console.log('NavigationManagerCordova goTo ', {
                  urlToGoTo: url,
                  pushToHistory: pushToHistory
                });

                if (!(url !== _Constants.TOPIC_CHOOSER_PATH && url !== _Constants.SETTINGS_PATH && url !== _Constants.USER_PATH && url !== _Constants.FAVS_PATH && url !== _Constants.GLOSSARY_PATH && url !== _Constants.REGISTER_PATH && url !== _Constants.UPDATE_PATH)) {
                  _context.next = 28;
                  break;
                }

                path = url.split('/');
                lastId = path.length > 1 ? path[1] : null;
                pathSpocRootId = path.length > 1 ? path[1].split(_KesiConstants.KESI_PATH_DELIMITER)[0] : null; // check if content is available and rootId is our given target root id -> update if not

                if (!(!_ContentStore["default"].contentWithIdIsAvailable(lastId) && pathSpocRootId === _config["default"].rootId)) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 16;
                _context.next = 19;
                return (0, _AppUtils.updateContent)(false, false, null, false);

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](16);
                console.log("failed navigating to ".concat(url, " because page was not available and content update failed"));
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 25:
                /*
                let attempts = 0
                while (!ContentStore.contentWithIdIsAvailable(lastId) && attempts < 10) {
                  await new Promise(resolve => setTimeout(resolve, 400))
                  attempts++
                }
                 */
                if (_ContentStore["default"].contentWithIdIsAvailable(lastId)) {
                  this.currentPath.push(url);
                } // else NavigationManagerCordova.goHome()


                _context.next = 29;
                break;

              case 28:
                this.currentPath.push(url);

              case 29:
                if (pushToHistory) {
                  _reactRouter.hashHistory.push(url);
                }

                if (!dontSetIsChanging) {
                  this.isChangingUrl = false;
                }

                return _context.abrupt("return", _promise["default"].resolve());

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[16, 21]]);
      }));

      function goTo(_x) {
        return _goTo.apply(this, arguments);
      }

      return goTo;
    }()
  }, {
    key: "setScrollTop",
    value: function setScrollTop(top) {
      this.scrollTop = top;
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return this.scrollTop;
    }
    /**
     * This goes to the <Home> component which then decides which page to open depending on target config.
     * Defaults to first page of root chapter.
     * @param reloadPage If set to true, the whole web app reloads prior to going to that page.
     * @param params
     */

  }, {
    key: "goHome",
    value: function () {
      var _goHome = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var reloadPage,
            params,
            newPath,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reloadPage = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
                params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
                console.log('gohome called', this.currentPath);
                newPath = '/';

                if (params) {
                  newPath += '?' + (0, _keys["default"])(params).map(function (k) {
                    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
                  }).join('&');
                }

                _context2.next = 7;
                return (0, _TimeoutHelper.timeout)();

              case 7:
                this.currentPath = [];

                if (reloadPage) {
                  _reactRouter.hashHistory.replace(newPath); // on iOS sometimes the page is not reloaded with the previous command so just make sure the page is reloaded


                  if (window) {
                    window.location.reload();
                  }
                } else {
                  _reactRouter.hashHistory.push(newPath);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function goHome() {
        return _goHome.apply(this, arguments);
      }

      return goHome;
    }() // getLocation(path) {
    //   let fragment = this.typeRouteMapping.default;
    //
    //   Object.values(path).some(course => {
    //     if (course.type === null) {
    //       throw new Error('something expected is not defined');
    //     }
    //     if (this.typeRouteMapping[course.type]) {
    //       fragment = this.typeRouteMapping[course.type];
    //       return true;
    //     }
    //     return course.inheritedTypes.some(type => {
    //       if (this.typeRouteMapping[type]) {
    //         fragment = this.typeRouteMapping[type];
    //         return true;
    //       }
    //       return false;
    //     });
    //   });
    //
    //   return `${fragment}/${path[path.length - 1].id}`;
    // }
    // async getCoursePath(course, oldPath) {
    //   return Promise.resolve(oldPath);
    //
    //   // const path = oldPath || [course];
    //   // if (course.parent) {
    //   //   try {
    //   //     const parent = await CourseLoader.getCourse(course.parent);
    //   //     path.unshift(parent);
    //   //     return this.getCoursePath(parent, path);
    //   //   }
    //   //   catch(error) {
    //   //     return Promise.reject(error);
    //   //   }
    //   //   /* return getCourse(course.parent).then((parent) => {
    //   //     path.unshift(parent);
    //   //     return this.getCoursePath(parent, path);
    //   //   }); */
    //   // }
    //   //
    //   // return Promise.resolve(path);
    // }

  }, {
    key: "handleLink",
    value: function handleLink(url) {
      var match = url.match(/^#?(.+?):\/\//); // match[0] contains the whole match, match[1] contains only the first capture group

      var protocol = match[1];

      switch (protocol) {
        // case 'emscourse':
        // case 'emscontent': {
        //   const targetId = url.match(new RegExp(`.{${match[0].length}}(.+?)/`))[1];
        //   this.goTo(targetId);
        //   return;
        // }
        // case 'http':
        // TODO handle link in app
        // case 'browse':
        // TODO handle link in app (but handle url parsing differently than for http)
        // case 'media':
        // TODO implement
        default:
          console.error("unimplemented link type ".concat(protocol, " in url ").concat(url));
      }
    }
  }, {
    key: "addOnPathChangeListener",
    value: function addOnPathChangeListener(listener) {
      this.onPathChangeListeners.push(listener);
    }
  }, {
    key: "notifyOnPathChangeListeners",
    value: function notifyOnPathChangeListeners() {
      var _this = this;

      this.onPathChangeListeners.forEach(function (listener) {
        if (!listener) {
          throw new Error('something expected is not defined');
        }

        listener(_this.currentPath);
      });
    }
  }], [{
    key: "instance",
    value: function instance() {
      if (!_instance) {
        _instance = new NavigationManagerCordova();
      }

      return _instance;
    } // initTypeRouteMapping() {
    //
    //   console.log({target});
    //
    //   const targetTypeRouteMap = target.targetFeatures.reduce((acc, val) => {
    //     return Object.assign(acc, val.FEATURE_TYPE_ROUTE_MAPPING);
    //   }, {});
    //
    //   return Object.assign({}, defaultTypeRouteMap, targetTypeRouteMap);
    // }
    //
    // static goBack() {
    //   return NavigationManagerCordova.instance().goBack();
    // }
    //
    // async goBack(){
    //   if(this.lastCourseId){
    //     this.goTo(this.lastCourseId.id, false);
    //   }
    //   hashHistory.goBack();
    // }

  }, {
    key: "jumpToKesiUrl",
    value: function () {
      var _jumpToKesiUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(url, prevUrl) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                NavigationManagerCordova.instance().goTo(url, true, false, prevUrl);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function jumpToKesiUrl(_x2, _x3) {
        return _jumpToKesiUrl.apply(this, arguments);
      }

      return jumpToKesiUrl;
    }()
    /**
     * Call this method if you know the id you have belongs to a course.
     * @param url
     * @param urlToSwitchToFirst
     * @param dontSetIsChanging
     */

  }, {
    key: "goTo",
    value: function () {
      var _goTo2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(url) {
        var urlToSwitchToFirst,
            dontSetIsChanging,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                urlToSwitchToFirst = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : null;
                dontSetIsChanging = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;

                if (urlToSwitchToFirst) {
                  NavigationManagerCordova.instance().goTo(urlToSwitchToFirst, true, true);
                }

                return _context4.abrupt("return", NavigationManagerCordova.instance().goTo(url, true, dontSetIsChanging));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function goTo(_x4) {
        return _goTo2.apply(this, arguments);
      }

      return goTo;
    }()
  }, {
    key: "goBack",
    value: function goBack() {
      NavigationManagerCordova.instance().goBack();
    }
  }, {
    key: "jumpBack",
    value: function jumpBack() {
      NavigationManagerCordova.instance().jumpBack();
    }
  }, {
    key: "goBackButButtonDisabled",
    value: function goBackButButtonDisabled() {
      console.log('backButton disabled');
    }
  }, {
    key: "setBackFunc",
    value: function setBackFunc(func) {
      console.log('settingBackFunc');
      NavigationManagerCordova.instance().globalBackFunc = func;
    }
  }, {
    key: "getCurrentId",
    value: function getCurrentId() {
      return NavigationManagerCordova.instance().getCurrentId();
    }
  }, {
    key: "getUsedJump",
    value: function getUsedJump() {
      return NavigationManagerCordova.instance().getUsedJump();
    }
  }, {
    key: "getCurrentPath",
    value: function getCurrentPath() {
      return NavigationManagerCordova.instance().getCurrentPath();
    }
  }, {
    key: "setScrollTop",
    value: function setScrollTop(top) {
      NavigationManagerCordova.instance().setScrollTop(top);
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return NavigationManagerCordova.instance().getScrollTop();
    }
  }, {
    key: "goHome",
    value: function goHome() {
      var reloadPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      NavigationManagerCordova.instance().goHome(reloadPage, params);
    }
  }, {
    key: "handleLink",
    value: function handleLink(url) {
      NavigationManagerCordova.instance().handleLink(url);
    }
  }, {
    key: "addOnPathChangeListener",
    value: function addOnPathChangeListener(listener) {
      NavigationManagerCordova.instance().addOnPathChangeListener(listener);
    }
  }]);
  return NavigationManagerCordova;
}(); // temporarily only


(0, _defineProperty2["default"])(NavigationManagerCordova, "setNavbarBackgroundColor", function (color) {
  NavigationManagerCordova.instance().navbarBackgroundColor = color;
});
(0, _defineProperty2["default"])(NavigationManagerCordova, "getNavbarBackgroundColor", function () {
  return NavigationManagerCordova.instance().navbarBackgroundColor;
});
window.goTo = NavigationManagerCordova.goTo;
window.goToKesiUrl = NavigationManagerCordova.jumpToKesiUrl;
var _default = NavigationManagerCordova;
exports["default"] = _default;